(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSFuncionDeleteController',SSFuncionDeleteController);

    SSFuncionDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSFuncion'];

    function SSFuncionDeleteController($uibModalInstance, entity, SSFuncion) {
        var vm = this;

        vm.sSFuncion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSFuncion.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
